import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AccessibilityCms } from '../../interfaces/accessibility-cms.interface';
import { lmwBaseRoutes } from '../../routing/route-locales/lmw-base-routes';

@Component({
  selector: 'lmw-base-accessibility',
  templateUrl: './accessibility.component.html'
})
export class AccessibilityComponent implements OnInit {

  public accessibilityCmsData: AccessibilityCms;
  public mobileBackButtonText = lmwBaseRoutes.homeLinkText;

  constructor(private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.accessibilityCmsData = this.route.snapshot.data.cmsData;
  }
}
